import { RelyingPartiesState } from "@idw-types/state/relying-parties-state";
import { RelyingPartiesActionTypes, RelyingPartiesActions } from "../actions/relying-parties-actions";
import { AxnRelyingParty, FormattedAxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { updateEntityStatus } from "@utils/object-util";

export const initialRelyingPartiesState: RelyingPartiesState = {
    relyingParties: {
        relyingParties: null,
        isLoading: false
    }
}

export const relyingPartiesReducer = (
    state: RelyingPartiesState = initialRelyingPartiesState,
    action: RelyingPartiesActions
): RelyingPartiesState => {
    switch (action.type) {
        // Relying Parties
        case RelyingPartiesActionTypes.SET_RELYING_PARTIES_LOADING:
            return {
                ...state,
                relyingParties: {
                    ...(action.payload.isLoading
                        ? { ...initialRelyingPartiesState.relyingParties }
                        : { ...state.relyingParties }),
                    isLoading: action.payload.isLoading
                }
            };
        case RelyingPartiesActionTypes.SET_RELYING_PARTIES:
            return {
                ...state,
                relyingParties: {
                    relyingParties: action.payload.relyingParties,
                    isLoading: false
                }
            };
        case RelyingPartiesActionTypes.ADD_RELYING_PARTY:
            return {
                ...state,
                relyingParties: {
                    ...state.relyingParties,
                    relyingParties: state.relyingParties.relyingParties
                        ? [...state.relyingParties.relyingParties, action.payload.relyingParty]
                        : [action.payload.relyingParty]
                }
            };
        case RelyingPartiesActionTypes.UPDATE_RELYING_PARTIES: {
            return {
                ...state,
                relyingParties: {
                    ...state.relyingParties,
                    relyingParties: updateEntityStatus<FormattedAxnRelyingParty, AxnRelyingParty>(
                        state.relyingParties.relyingParties,
                        action.payload.updatedRelyingParty, action.payload.accountState
                    )
                }
            }
        }
        default:
            return state;
    }
};